import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { addIaImages, askIa } from "../../REDUX/actions/ia";
import IaImagePreview from "./IaImagePreview";
import { IaClipSvg, IaSendSvg } from "./IaIcons";

/**
 * Zone de saisie.
 *
 * Volontairement un textarea et non le RichTextEditor Quill du projet : une
 * barre gras/italique/liste n'a pas de sens pour poser une question, et Quill
 * produirait du HTML la ou le back attend du texte brut.
 */
const IaComposer = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const fileInputRef = useRef(null);
  const [question, setQuestion] = useState("");

  const { asking, streamingMessageId, pendingImages } = useSelector(
    (state) => state.iaReducer
  );

  const uploadingImage = pendingImages.some((image) => image.uploading);
  const busy = asking || Boolean(streamingMessageId);
  const canSend = question.trim().length > 0 && !busy && !uploadingImage;

  const locale = (i18n.language || "fr").slice(0, 2);

  const send = () => {
    if (!canSend) return;
    const value = question.trim();
    setQuestion("");
    dispatch(askIa(value, locale, t));
  };

  const handleKeyDown = (event) => {
    // Entree envoie, Maj+Entree passe a la ligne : convention attendue d'un chat.
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      send();
    }
  };

  return (
    <div className="iaComposer border-top pt-2">
      <IaImagePreview />

      <div className="alignH gap-2 px-3 pb-3">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          multiple
          className="d-none"
          onChange={(event) => {
            dispatch(addIaImages(event.target.files, t));
            // Remise a zero pour pouvoir reselectionner le meme fichier ensuite.
            event.target.value = "";
          }}
        />

        <button
          type="button"
          className="iaComposerIcon border-0 bg-transparent"
          title={t("Attach an image")}
          disabled={busy}
          onClick={() => fileInputRef.current?.click()}
        >
          <IaClipSvg />
        </button>

        <textarea
          className="iaComposerInput br5 p-2 flex-grow-1 b-1-darkGrey f14"
          rows={1}
          placeholder={t("Ask me a question about a spa model or advice on the sales approach")}
          value={question}
          disabled={busy}
          onChange={(event) => setQuestion(event.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button
          type="button"
          className={`iaComposerSend br5 border-0 alignC ${
            canSend ? "iaBgBlue" : "bg-lightGrey"
          }`}
          disabled={!canSend}
          onClick={send}
          title={t("Send")}
        >
          {busy ? (
            <Spinner animation="border" variant="light" size="sm" />
          ) : (
            <IaSendSvg color={canSend ? "#ffffff" : "#9aa3ad"} />
          )}
        </button>
      </div>
    </div>
  );
};

export default IaComposer;
